/**
 * This service used to call POST API URL to different rules throught application
 */
/**
 * Import required modules/plugin
 */
import Vue from 'vue';
import axios from '../axios-config';
import store from '../store/store';

const rulesAPI = {
  postRuleDashboard(requestParams) {
    /* eslint no-param-reassign: "error" */
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url, requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  putRuleDashboard(requestParams) {
    return new Promise((resolve, reject) => {
      axios.put(requestParams.url, requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  deleteRuleDashboard(requestParams) {
    return new Promise((resolve, reject) => {
      axios.delete(requestParams.url)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * This function used to call all rules which are based on different field elements
   * like select box, textbox, radio etc.
   * @param {*} requestParams contains all form data
   * returns fields, navigation tab, buttons node based on rule.
   * fields returned through this API call get reflected on UI
   */
  postRule(requestParams) {
    /* eslint no-param-reassign: "error" */
    /**
     * get session id from vuex store to pass into request
     * Note: this code can be modifie to pass request along with session_id
     */
    /* eslint-disable */
    requestParams.data.session_id = requestParams.data.session_id === ''? store.getters.getSessionID : requestParams.data.session_id;
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url, requestParams.data)
        .then((res) => {
          /**
           * set tab_buttons data into vuex store which is used in differnt places
           * button.js store used for action, mutation and getters for button actions
           */
          if(!sessionStorage.getItem("setRc2NavFlowAction")){
          store.dispatch('setButtonDataAction', res.data);
          console.log('we are here for auto',res.data);
          }
          else
          {
          console.log('we are here for home', res.data);
          
          store.dispatch('setButtonDataAction', store.getters.finalNavData);
          }
          /**
           * resolve promised on successfull response
           */
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  /**
   * This function used to call all navigation tab rule where user moved from
   * one tab to other tab. Form post need to call in all navigation
   * Accepts formData as parameter contains all form field name and field value object
   * returns new navigation url where user going route after API call
   */
  navigationFormPost(formDataArr) {
    /**
     * Prepared form data from vuex store and function parameters
     */
    const formData = {
      session_id: store.getters.getSessionID,
      page_name: store.getters.getPageName,
      fields: formDataArr.data,
    };
    if (formDataArr.c_page_name) {
      formData.page_name = formDataArr.c_page_name;
      formData.session_id = formDataArr.c_session_id;
    }
    if (formDataArr.payment_session_id) {
      formData.payment_session_id = formDataArr.payment_session_id;
      formData.page_name = formDataArr.page_name;
      formData.session_id = formDataArr.session_id;
    }
    return new Promise((resolve, reject) => {
      axios.post(formDataArr.url, formData)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  vgsNavigationFormPost(formDataObj, vgsFormObj, submittedFrom) {
    store.dispatch('setLoaderStatus', {
      method: 'post',
      url: '/navs/',
    });

    // console.log(formDataObj.data, "FORM OBJ");
    let expectedOrder = store.getters.getVgsIndexes;
    if (submittedFrom === 'bundle') {
      expectedOrder = store.getters.getHomeVgsIndexes;
    }
    let frontArr = [];
    let backArr = [];

    // VGS requires the index values of each VGS field (e.g., InputVgsCreditcard.vue's name: fields[X].field_value) to correspond 
    // with the associated payload's location of field.
    // For example: If the payload's fields array has QTE_Creditcard at index 0, the VGS component is initialized with the 0 in the fieldSettings.name property.
    // Since vue components are initialized before vgsNavigationFormPost is run, this method needs to reorder the payload's fields array to make sure that
    // the initialized indexes will match the payload being sent.
    // Checkout.vue updates store at setVgsIndexes. 
    formDataObj.data.forEach((el) => {
      // expectedOrder keys are first used to check if el is a payment field
      if (Number.isInteger(expectedOrder[el.field_name])) {
        // once found, the front of the array is populated by index values in expectedOrder.
        frontArr[expectedOrder[el.field_name]] = el;
      } else {
        // all others are put in the back
        backArr.push(el);
      }
    });

    let orderedFields = [...frontArr, ...backArr];

    const formData = {
      session_id: store.getters.getSessionID,
      page_name: store.getters.getPageName,
      fields: orderedFields,
    };
    //TODO : added condition to use below code only for bind from bundle
    const flowType = sessionStorage.getItem('flowType');
    if (flowType === 'bundle' && submittedFrom === 'auto') {
      formData.payment_session_id = store.getters.getSameHomeBillingInfo ? JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId : '';
      formData.page_name = sessionStorage.getItem('autoPageName');
      formData.session_id = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
    } else if (flowType === 'bundle' && submittedFrom === 'bundle') {
      formData.page_name = sessionStorage.getItem('homePageName');
      formData.session_id = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;
    }
    const additionalHeaders = { Pragma: 'no-cache', 'X-Frame-Options': 'SAMEORIGIN', 'X-XSS-Protection': '1; mode=block' };

    return new Promise((resolve, reject) => {
      if (vgsFormObj && vgsFormObj.submit) {
        vgsFormObj.submit(formDataObj.url, {
          data: formData,
          mapDotToObject: 'mergeArray',
          headers: {
            ...additionalHeaders,
            'Authorization': `Bearer ${Vue.prototype.$auth.getAccessToken()}`,
          },
          withCredentials: true,
        }, (status, response) => {
          if (status == 200) {
            store.dispatch('setLoaderStatus', {});
            resolve(response);
          } else {
            store.dispatch('setLoaderStatus', {});
            reject({status, response});
          }
        });
      } else {
        store.dispatch('setLoaderStatus', {});
        console.log('VGS form is undefined');
      }
    });
  },
  /**
   * plain form post for add vehicle or driver or incident
   * Not in use
   */
  addFormPost(formDataArr) {
    /**
     * Prepared form data from vuex store and function parameters
     */
    const formData = {
      session_id: store.getters.getSessionID,
      page_name: store.getters.getPageName,
      fields: formDataArr.data,
    };
    return new Promise((resolve, reject) => {
      axios.post(formDataArr.url, formData)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  submitForceBind(url, requestBody) {
    return new Promise((resolve, reject) => {
      axios.post(url, requestBody)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  getEpicImportSession(requestParams){
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url,requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  exportQuoteEpic(requestParams){
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url,requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  clickkeytrackers(requestParams) {
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url,requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  async generatePDF(requestParams) {
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url,requestParams.data, {responseType: 'blob'})
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  submitPostRequest(url, requestBody) {
    return new Promise((resolve, reject) => {
      axios.post(url, requestBody)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
};
/**
 * export service to used by different components
 */

export default rulesAPI;



// WEBPACK FOOTER //
// ./src/services/postData.js